import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

type DisconnectSocialType = {
  provider: "google" | "apple";
};

export const useDisconnectSocial = (
  options?: UseMutationOptions<any, Error, DisconnectSocialType>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["disconnectSocial"],
    mutationFn: async ({ provider }: DisconnectSocialType) => {
      return axiosInstance
        .delete(`/auth/${provider}/disconnect`)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa usuwanie metody logowania...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "disconnectSocial",
      });
      if (options?.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Metoda logowania została usunięta",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "disconnectSocial",
      });
      queryClient.invalidateQueries({ queryKey: ["me"] });
      queryClient.invalidateQueries({ queryKey: ["socialAccounts"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas usuwania metody logowania",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "disconnectSocial",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
